import React, { useState } from "react";
import {
  AddInternalInfoLayout,
  Form,
  SubmitButton,
} from "./AddInternalGroup.style";
import { DrawerDivider } from "../layout/RightDrawer.style";
import { useTranslation } from "hhn-commons";
import InputGroupName from "./InputFields/InputGroupName";
import InputGroupAbout from "./InputFields/InputGroupAbout";
import {
  IGroupInfo,
  IInternalGroupData,
  IMediaDraft,
} from "@home-health-notify/domain";
import InputGroupPhoto from "./InputFields/InputGroupPhoto";

type AddInternalGroupInfoProps = {
  addInternalGroupInfo: (data: IInternalGroupData) => void;
  onSetInternalGroupData: (data: IInternalGroupData) => void;
  internalGroupData: IInternalGroupData;
  groupInfo?: IGroupInfo | undefined;
  setGroupImage: (groupImage: IMediaDraft) => void;
  isLoading: boolean;
};
export const AddInternalGroupInfo = ({
  addInternalGroupInfo,
  onSetInternalGroupData,
  internalGroupData,
  groupInfo,
  setGroupImage,
  isLoading,
}: AddInternalGroupInfoProps) => {
  const { t } = useTranslation();

  const [isError, setIsError] = useState<boolean>(false);

  const onFormDataChange = (key: string, value: string) => {
    onSetInternalGroupData({
      ...internalGroupData,
      [key]: value,
    });
  };

  const validateFormData = () => {
    return !internalGroupData.groupName || isError;
  };

  const onNextClick = () => {
    addInternalGroupInfo(internalGroupData);
  };

  const { groupName, about, image } = internalGroupData;
  const buttonLabel = groupInfo
    ? t("buttonLabels.update")
    : t("buttonLabels.next");

  const onImageChange = async (uploadedImage: IMediaDraft) => {
    setGroupImage(uploadedImage);
  };

  return (
    <AddInternalInfoLayout>
      <Form>
        <InputGroupPhoto
          src={image}
          name={groupName || ""}
          onImageChange={onImageChange}
        />
        <InputGroupName
          value={groupName}
          onNameChange={onFormDataChange}
          isError={isError}
          setIsError={setIsError}
        />
        <InputGroupAbout value={about} onAboutChange={onFormDataChange} />
      </Form>
      <DrawerDivider />
      <SubmitButton
        variant="contained"
        disabled={validateFormData()}
        onClick={onNextClick}
        data-testid="next button"
        loading={isLoading}
      >
        {buttonLabel}
      </SubmitButton>
    </AddInternalInfoLayout>
  );
};
